module.exports = __webpack_public_path__ + "img/hr-burner-inserter-hand-open.83815cc2.png";